/**
 * OrchestratorService - Frontend API client for orchestrator data.
 * Fetches real-time cluster and cost data via the Worker proxy.
 */

const API_URL = process.env.REACT_APP_API_URL || 'https://api.tcf-studio.dev';

const getHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

/**
 * Get all cluster statuses from orchestrator (source of truth)
 */
export const getOrchestratorStatus = async () => {
  try {
    const response = await fetch(`${API_URL}/orchestrator/status`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to fetch status');
    return data;
  } catch (error) {
    console.error('Orchestrator status error:', error);
    throw error;
  }
};

/**
 * Get cost report from orchestrator
 * @param {number} days - Number of days to report on (default: 30)
 */
export const getCostReport = async (days = 30) => {
  try {
    const response = await fetch(`${API_URL}/orchestrator/cost_report?days=${days}`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      const err = new Error(data.error || 'Failed to fetch cost report');
      err.status = response.status;
      throw err;
    }
    return data;
  } catch (error) {
    if (!error.status) console.error('Cost report error:', error);
    throw error;
  }
};

export default {
  getOrchestratorStatus,
  getCostReport
};
